/*
 * Public API Surface of sol-wallets
 */

export * from './lib/sol-wallets.service';
export * from './lib/sol-wallets.component';
export * from './lib/sol-wallets.module';
export * from './lib/wallets/wallet' ;